var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { getClassName } from '../../../utils/ui/classes';
const baseClasses = ['form-field', 'block', 'flex-none', 'w-full'];
const TextArea = forwardRef((_a, ref) => {
    var { className, style, error, passEventOnChange, onChange } = _a, props = __rest(_a, ["className", "style", "error", "passEventOnChange", "onChange"]);
    function handleChange(e) {
        if (onChange) {
            if (passEventOnChange) {
                onChange(e);
            }
            else {
                onChange(e.target.value);
            }
        }
    }
    return (
    /* eslint-disable jsx-a11y/no-autofocus */
    (React.createElement("textarea", Object.assign({ ref: ref, className: getClassName(baseClasses, { error: error === null || error === void 0 ? void 0 : error.message }, className), onChange: handleChange, "data-testid": "textArea" }, props))));
});
TextArea.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
        PropTypes.object,
    ]),
    style: PropTypes.object,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    placeholder: PropTypes.string,
    autoComplete: PropTypes.string, // input autocomplete
    autoFocus: PropTypes.bool,
    onBlur: PropTypes.func,
    disabled: PropTypes.bool,
    rows: PropTypes.number,
};
TextArea.defaultProps = {
    rows: 3,
};
export default TextArea;
